import { z } from "zod";
import { UploadedFileBucket } from "../UploadedFileBucket.js";

export const uploadedFileBucketSchema = z.nativeEnum(UploadedFileBucket);
